<template>
  <ul class="tab01">
    <li :class="{'on': currentUrl=='/terms/use'}"><a href="/terms/use">서비스 이용약관</a></li>
    <li :class="{'on': currentUrl=='/terms/privacy'}"><a href="/terms/privacy">개인정보 처리방침</a></li>
    <li :class="{'on': currentUrl=='/terms/financial'}"><a href="/terms/financial">전자금융거래 기본약관</a></li>
  </ul>

  <div class="select-wrap">
    <select class="select" onchange="window.open(value,'_self');">
      <option value="/terms/use" label="서비스 이용약관" selected>서비스 이용약관</option>
      <option value="/terms/privacy" label="개인정보 처리방침">개인정보 처리방침</option>
      <option value="/terms/financial" label="전자금융거래 기본약관">전자금융거래 기본약관</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "TermsNavi",
  data() {
    return {
      currentUrl: ''
    };
  },
  mounted: function() {
    this.currentUrl = window.location.pathname;
    console.debug(this.currentUrl);
  }
}
</script>

<style scoped>

</style>